import { api } from "./client.js";
import { DEMO_MATCH_RESULT, DEMO_HISTORY } from "./mock.js";
// Inline to avoid stale-module cache issues in dev — mock.ts may lag HMR
const DEMO_SCOUT_RESULT = {
    snapshotId: null,
    opponent: { firstName: "ShadowBot", rating: 530, isBot: true },
    units: [
        { ref: "p2_s1", unitDefId: "bastion", role: "tank", slot: 1, alive: true, hp: 125, maxHp: 125, shield: 0, attack: 22, defense: 12, speed: 9, skillPower: 29, skillCooldown: 3, skillMaxCd: 3, statuses: { stun: 0, shielded: 0, healBoost: 0, silenced: 0 } },
        { ref: "p2_s2", unitDefId: "null_", role: "hacker", slot: 2, alive: true, hp: 138, maxHp: 138, shield: 0, attack: 19, defense: 9, speed: 14, skillPower: 29, skillCooldown: 3, skillMaxCd: 3, statuses: { stun: 0, shielded: 0, healBoost: 0, silenced: 0 } },
        { ref: "p2_s3", unitDefId: "pulse", role: "support", slot: 3, alive: true, hp: 125, maxHp: 125, shield: 0, attack: 19, defense: 12, speed: 12, skillPower: 29, skillCooldown: 3, skillMaxCd: 3, statuses: { stun: 0, shielded: 0, healBoost: 0, silenced: 0 } },
    ],
};
const demo = import.meta.env.VITE_DEMO_MODE === "true";
export const matchApi = {
    scout: () => demo
        ? new Promise(r => setTimeout(() => r(DEMO_SCOUT_RESULT), 800))
        : api.get("/match/scout"),
    play: (opts) => demo
        ? new Promise(r => setTimeout(() => r(DEMO_MATCH_RESULT), 1500))
        : api.post("/match/play", opts ?? {}),
    history: () => demo
        ? Promise.resolve({ matches: DEMO_HISTORY })
        : api.get("/match/history"),
    detail: (id) => api.get(`/match/${id}`),
    // Called after battle animation finishes — triggers TG notification to attacker
    ack: (id) => api.post(`/match/${id}/ack`, {}),
};
